import React from 'react';
import { UNITY_BUILDS, UNITY_ASSETS_URL, appDataByKey } from 'Settings';
import { withRouter } from 'react-router';
import { fetchGameLinks, postLogin } from '../../api';

const getDisplayName = WrappedComponent => {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

export default function gameContext(WrappedComponent) {
  class DecoratedComponent extends React.Component {
    constructor(props) {
      super(props);

      const gameSlug = props.match.params.gameSlug || props.gameSlug;
      const gameData = appDataByKey[gameSlug];
      const gameBuild = UNITY_BUILDS[gameSlug];
      const { buildNumber, buildTarget, buildType, unityVersion } = gameBuild;

      const urlBase = `${UNITY_ASSETS_URL}${gameSlug}/${buildTarget}/${buildNumber}/`;
      const gameSettings =
        unityVersion === 'unity-5.4'
          ? {
              data: `${urlBase}WebGL.datagz`,
              memory: `${urlBase}WebGL.memgz`,
              game: `${urlBase}WebGL.jsgz`,
              loader: `${urlBase}UnityLoader.js`,
            }
          : {
              dataUrl: `${urlBase}${buildTarget}.data.unityweb`,
              asmCodeUrl: `${urlBase}${buildTarget}.asm.code.unityweb`,
              asmMemoryUrl: `${urlBase}${buildTarget}.asm.memory.unityweb`,
              asmFrameworkUrl: `${urlBase}${buildTarget}.asm.framework.unityweb`,
              loader: `${urlBase}UnityLoader.js`,
              webglJsonUrl: `${urlBase}${buildTarget}.json`,
            };

      if (buildType && buildType === 'WebAssembly') {
        gameSettings.wasmCodeUrl = `${urlBase}${buildTarget}.wasm.code.unityweb`;
        gameSettings.wasmFrameworkUrl = `${urlBase}${buildTarget}.wasm.framework.unityweb`;
      }
      gameSettings.unityVersion = unityVersion;
      gameSettings.buildSettings = gameBuild;
      gameData.loadingFinishedEvent =
        buildNumber > gameBuild.appInitializedAfter
          ? 'gameInitialized'
          : 'gameLoaded';
      if (props.match.params && props.match.params.topicSlug) {
        const initialScene = gameData.deepLinks[props.match.params.topicSlug];
        gameData.initialScene =
          typeof initialScene === 'object'
            ? initialScene
            : { sceneName: initialScene };
      }

      this.state = {
        gameData,
        gameSettings,
      };
    }

    render() {
      const { gameData, gameSettings } = this.state;
      return (
        <WrappedComponent
          {...this.props}
          {...gameData}
          gameSettings={gameSettings}
        />
      );
    }
  }

  DecoratedComponent.displayName = `gameContext(${getDisplayName(
    WrappedComponent
  )})`;
  return withRouter(DecoratedComponent);
}
